import { FolderShareType } from "@zapier/bff";
import { FolderShare } from "@zapier/client";

export function createFolderShareFromId(id: string) {
  return {
    id,
    shareType: id.split("_")[0] as FolderShareType,
    shareId: Number.parseInt(id.split("_")[1]),
  } as FolderShare;
}
